import { Typography } from "@mui/material";

const PageNotFound = () => {
  return <Typography>Page not found.</Typography>;
};

export default PageNotFound;
